<div class="card shadow mb-3">
	<h5 class="card-header">Szerverek</h5>
	<div class="card-body text-center">
		<button class="btn btn-dark me-3" onclick="Anvil.exec('main/action_display_traffic', '<%- Anvil.moment(stat_date).subtract(1, 'days').format('YYYY-MM-DD') %>')"><i class="fa fa-fw fa-arrow-left"></i></button>
		<div class="d-inline-block" style="vertical-align:top;">
			<h4 class="my-0"><%= Anvil.moment(stat_date).format('YYYY. MM. DD.') %></h4>
			<small><%= (stat_date == Anvil.moment().startOf('day').format('YYYY-MM-DD')) ? 'ma' : Anvil.moment(stat_date).from(Anvil.moment().startOf('day')) %></small>
		</div>
		<button class="btn btn-dark ms-3 <% if (stat_date == Anvil.moment().startOf('day').format('YYYY-MM-DD')) { %>disabled<% } %>" onclick="Anvil.exec('main/action_display_traffic', '<%- Anvil.moment(stat_date).add(1, 'days').format('YYYY-MM-DD') %>')"><i class="fa fa-fw fa-arrow-right"></i></button>
	</div>
</div>

<div class="row g-3 mb-3">
	<div class="col">
		<div class="card shadow">
			<h5 class="card-header"><i class="fa fa-server me-2"></i>UGYFEL</h5>
			<div class="card-body">

				<small class="float-end text-dim">4 mag</small>
				<strong class="my-2">Terhelés</strong>
				<%- include('/ui/chart', {
					params: {
						type: 'bar',
						data: {
							datasets: [{
								label: 'Terhelés',
								data: stat_log,
								parsing: {
									xAxisKey: 'data_dt',
									yAxisKey: 'd1_load15'
								},
								backgroundColor: function(context) {
									const value = context.raw.d1_load15
									if (value > 4) {
										return 'rgb(255, 50, 57)';
									} else if (value > 3.33) {
										return 'rgb(204, 101, 37)';
									} else if (value > 2.66) {
										return 'rgb(170, 145, 57)';
									} else {
										return 'rgb(115, 168, 57)';
									}
								}
							}]
						},
						options: {
							aspectRatio: 5,
							interaction: {
								intersect: false,
								mode: 'index',
							},
							scales: {
								x: {
									stacked: true,
									type: 'time',
									time: {
										unit: 'hour',
										tooltipFormat: 'HH:mm',
										displayFormats: {
											hour: 'HH'
										}
									},
									min: Anvil.moment(stat_date).toISOString(),
									max: Anvil.moment(stat_date).add(1, 'days').toISOString(),
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								},
								y: {
									suggestedMax: 5,
									stacked: true,
									beginAtZero: true,
									afterFit (scale) {
										scale.width = 40
									},
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								}
							},
							plugins: {
								legend: {
									display: false
								},
							}
						}
					}
				}) %>

				<strong class="my-2">Fogadott egyedi rendelések</strong>
				<%- include('/ui/chart', {
					params: {
						type: 'bar',
						data: {
							datasets: [{
								label: 'Új rendelés',
								data: stat_log,
								parsing: {
									xAxisKey: 'data_dt',
									yAxisKey: 'd1_new_orders'
								},
								backgroundColor: 'rgb(115, 168, 57)',
							}]
						},
						options: {
							aspectRatio: 4,
							interaction: {
								intersect: false,
								mode: 'index',
							},
							scales: {
								x: {
									stacked: true,
									type: 'time',
									time: {
										unit: 'hour',
										tooltipFormat: 'HH:mm',
										displayFormats: {
											hour: 'HH'
										}
									},
									min: Anvil.moment(stat_date).toISOString(),
									max: Anvil.moment(stat_date).add(1, 'days').toISOString(),
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								},
								y: {
									suggestedMax: 1000,
									stacked: true,
									beginAtZero: true,
									afterFit (scale) {
										scale.width = 40
									},
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								}
							},
							plugins: {
								legend: {
									display: false
								},
							}
						}
					}
				}) %>

				<strong class="my-2">Új rendelés összesítők és napi jelentések (NTAK)</strong>
				<%- include('/ui/chart', {
					params: {
						type: 'bar',
						data: {
							datasets: [{
								label: 'Új rendelés összesítő',
								data: stat_log,
								parsing: {
									xAxisKey: 'data_dt',
									yAxisKey: 'd1_new_order_summaries'
								},
								backgroundColor: 'rgb(115, 168, 57)',
							}, {
								label: 'Új nap zárás jelentés',
								data: stat_log,
								parsing: {
									xAxisKey: 'data_dt',
									yAxisKey: 'd1_new_day_reports'
								},
								backgroundColor: 'rgb(47, 164, 231)',
							}]
						},
						options: {
							aspectRatio: 4,
							interaction: {
								intersect: false,
								mode: 'index',
							},
							scales: {
								x: {
									stacked: true,
									type: 'time',
									time: {
										unit: 'hour',
										tooltipFormat: 'HH:mm',
										displayFormats: {
											hour: 'HH'
										}
									},
									min: Anvil.moment(stat_date).toISOString(),
									max: Anvil.moment(stat_date).add(1, 'days').toISOString(),
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								},
								y: {
									suggestedMax: 800,
									stacked: true,
									beginAtZero: true,
									afterFit (scale) {
										scale.width = 40
									},
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								}
							},
							plugins: {
								legend: {
									display: false
								},
							}
						}
					}
				}) %>
			</div>
		</div>
	</div>
</div>

<div class="row g-3">
	<div class="col">
		<div class="card shadow">
			<h5 class="card-header"><i class="fa fa-server me-2"></i>Hodor 2</h5>
			<div class="card-body" style="padding-bottom:19px;">

				<small class="float-end text-dim">8 mag</small>
				<strong class="my-2">Terhelés</strong>
				<%- include('/ui/chart', {
					params: {
						type: 'bar',
						data: {
							datasets: [{
								label: 'Terhelés',
								data: stat_log,
								parsing: {
									xAxisKey: 'data_dt',
									yAxisKey: 'h_load15'
								},
								backgroundColor: function(context) {
									const value = context.raw.h_load15
									if (value > 8) {
										return 'rgb(255, 50, 57)';
									} else if (value > 6.66) {
										return 'rgb(204, 101, 37)';
									} else if (value > 5.33) {
										return 'rgb(170, 145, 57)';
									} else {
										return 'rgb(115, 168, 57)';
									}
								}
							}]
						},
						options: {
							aspectRatio: 5,
							interaction: {
								intersect: false,
								mode: 'index',
							},
							scales: {
								x: {
									stacked: true,
									type: 'time',
									time: {
										unit: 'hour',
										tooltipFormat: 'HH:mm',
										displayFormats: {
											hour: 'HH'
										}
									},
									min: Anvil.moment(stat_date).toISOString(),
									max: Anvil.moment(stat_date).add(1, 'days').toISOString(),
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								},
								y: {
									suggestedMax: 10,
									stacked: true,
									beginAtZero: true,
									afterFit (scale) {
										scale.width = 40
									},
									ticks: {
										color: 'rgb(166, 172, 178)'
									},
									border: {
										color: 'rgb(86, 92, 98)'
									}
								}
							},
							plugins: {
								legend: {
									display: false
								},
							}
						}
					}
				}) %>
			</div>
		</div>
	</div>
</div>

<%- include('/ui/components/timer', {
	params: {
		callback: () => {
			Anvil.exec('main/action_display_traffic', `${Anvil.moment(stat_date).format('YYYY-MM-DD')}`)
		},
		interval: 60000
	}
}) %>